<template>
  <svg width="35" height="40" viewBox="0 0 35 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_256_703)">
      <path d="M0.7274 18.2344C-0.239862 19.2109 -0.239862 20.7969 0.7274 21.7734L13.1084 34.2734C14.0756 35.25 15.6464 35.25 16.6137 34.2734C17.581 33.2969 17.581 31.7109 16.6137 30.7344L8.45002 22.5H32.1905C33.5601 22.5 34.6667 21.3828 34.6667 20C34.6667 18.6172 33.5601 17.5 32.1905 17.5H8.45776L16.606 9.26562C17.5732 8.28906 17.5732 6.70312 16.606 5.72656C15.6387 4.75 14.0679 4.75 13.1006 5.72656L0.719662 18.2266L0.7274 18.2344Z" fill="#F7EDD6"/>
    </g>
    <defs>
      <clipPath id="clip0_256_703">
        <rect width="34.6667" height="40" fill="white"/>
      </clipPath>
    </defs>
  </svg>
</template>